import { render, staticRenderFns } from "./NeumaticoHorizontalTable.vue?vue&type=template&id=4857f39e&scoped=true"
import script from "./NeumaticoHorizontalTable.vue?vue&type=script&lang=js"
export * from "./NeumaticoHorizontalTable.vue?vue&type=script&lang=js"
import style0 from "./NeumaticoHorizontalTable.vue?vue&type=style&index=0&id=4857f39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857f39e",
  null
  
)

export default component.exports